import { render, staticRenderFns } from "./EditTasks.vue?vue&type=template&id=3c804b42&scoped=true"
import script from "./EditTasks.vue?vue&type=script&lang=js"
export * from "./EditTasks.vue?vue&type=script&lang=js"
import style0 from "./EditTasks.vue?vue&type=style&index=0&id=3c804b42&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c804b42",
  null
  
)

export default component.exports